export default "__VITE_ASSET__03c23410__"